module.exports = __webpack_public_path__ + "img/delete.fd9b82ff.svg";